import { User, UserData } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import Store from '../Store/Store';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const userService = {
    saveUser: async (identifier: string, data: any): Promise<any> => {
        return requestClient.post<User>('/users/update/' + identifier, data);
    },

    getUser: async (identifier: string): Promise<{ data: User }> => {
        return requestClient.get<User>(`${resolveDemo() ? '/demo' : ''}/users/get/${identifier}`);
    },

    getUsers: async (): Promise<{ data: UserData[] }> => {
        return requestClient.get<UserData[]>(`${resolveDemo() ? '/demo' : ''}/users/get`);
    },

    getUsersByPage: async (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ): Promise<{ data: { data: User[]; total: number } }> => {
        const response = await requestClient.get<UserData>(`${resolveDemo() ? '/demo' : ''}/users/get`, {
            params: {
                page,
                itemsPerPage,
                query,
            },
        });
        return {
            data: {
                data: response.data.data,
                total: response.data.total,
            },
        };
    },

    getUsersByGroup: async (
        page: number,
        pageSize: number,
        groupIdentifier: string,
    ): Promise<{ data: { data: User[]; total: number } }> => {
        const response = await requestClient.get<{ data: User[]; total: number }>(
            `${
                resolveDemo() ? '/demo' : ''
            }/users/getusersbygroup/${groupIdentifier}?page=${page}&itemsPerPage=${pageSize}`,
        );
        return {
            data: response.data,
        };
    },

    logout: async (): Promise<any> => {
        return requestClient.post<void>('/logout');
    },
};
